var App = App || {};

App.Alert = (function ($) {
    'use strict';

    var $alerts;
    var $allAlerts;
    function init() {

        $alerts = $('.site-alert');
        $allAlerts = $('.site-alerts');
        $allAlerts.slick({
            dots: true,
            arrows: true,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="Previous Alert" tabindex="0" role="button" style="color:#fff;margin-right:10px;"><i class="fa-solid fa-chevron-left"></i></button> <span id="spnCounter" style="color:#fff;"></span>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="Next Alert" tabindex="0" role="button" style="color:#fff;margin-left:10px;"><i class="fa-solid fa-chevron-right"></i></button>',
            appendArrows: $(".pager-Count-cms"),
            appendDots: $(".pager-Count-cms1"),
            slidesToShow: 1,
            autoplay: false,
            adaptiveHeight: false,
            autoplaySpeed: 6000,
            infinite: true,
            centerMode: false,
            enterPadding: 0,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        dots: false,
                        autoplay: false
                    }
                }
            ]
        });

        //Arrows Change events and Pager load
        $allAlerts.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
            if (!slick.$dots) {
                return;
            }

            var i = (currentSlide ? currentSlide : 0) + 1;

            $('#spnCounter').text(i + ' of ' + (slick.$dots[0].children.length));
        });

        //Check if last alert in scroll to set css
        if ($alerts.length > 0) {
            if ($alerts.length == 1)
                $('.slick-active .site-alert .site-alert__text_container').addClass('site-alert-text-cont-first');
        }
        else
            $('.site-alerts-container').hide();

        //Pager default text
        $('#spnCounter').text('1 of ' + $alerts.length);

        //Dismiss button click event
        $(".site-alert__dismiss").on('click', function (e) {
            e.preventDefault();
            var slickAlertId = $('.slick-active .site-alert').data('alertid');
            var slickAlertIndex = $('.slick-active .site-alert').data('alertindex');
            //Remove the selected slick from scroll
            var currAlertIndextoRemove = $('.slick-slide:not(".slick-cloned") .site-alert').index($('.slick-slide:not(".slick-cloned") .site-alert[data-alertindex="' + slickAlertIndex+'"]'))
            $('.site-alerts').slick('slickRemove', currAlertIndextoRemove);
            //Set Cookies for the dismissed alert
            App.Cookies.setItem('AlertDismissed-' + slickAlertId, 'true', Infinity, '/', window.location.hostname, window.location.protocol === 'https:');
            //Check if any scroll items are pending, If last apply css if not hide the panel
            if ($('.site-alert').length > 0) {
                updateHeaderSpace();
                if ($('.site-alert').length == 1)
                    $('.slick-active .site-alert .site-alert__text_container').addClass('site-alert-text-cont-first');
            }
            else {
                $('.site-alerts-container').slideUp(400, function () {
                    updateHeaderSpace();
                });

                if (typeof (Storage) !== "undefined") {
                    sessionStorage.SiteAlertDismissed = 1;
                }
                $('.site-alerts-container').hide();
            }
        });

        //Check if alert is dismissed in current session to hide the alert
        if (typeof (Storage) !== "undefined") {
            if (sessionStorage.SiteAlertDismissed) {
                $('.site-alerts-container').hide();
            }
        }
        // Init the height of the alert itself
        $(".site-alert").css("max-height", "none");

        updateHeaderSpace();
        var max = getMaxHeight('.site-alert');

        setHeight('.site-alert', max);
        $(window).on("resize", UpdateHeaderSpaceIfAlertsArePresent);
    }

    function UpdateHeaderSpaceIfAlertsArePresent() {
        if ($(".site-alert").length > 0) {
            updateHeaderSpace();
        }
    }

    function getMaxHeight(className) {
        var max = 0;
        document.querySelectorAll(className).forEach(
            function (el) {
                console.info(Math.max(el.scrollHeight, max));
                if (el.scrollHeight > max) {
                    max = el.scrollHeight;
                }
            }
        );

        return max;
    }

    function setHeight(className, height) {
        document.querySelectorAll(className).forEach(
            function (el) {
                el.style.height = height + 'px';
            }
        );
    }

    // change the height of the header spacer to fit one or more alerts
    function updateHeaderSpace() {
        var headerHeight = $(".headernav").height();
        $(".header-spacer").height(headerHeight);
        $('.sticky-login-bar .onlinebanking').css("top", $(".headernav").outerHeight() + "px");
        $(".onlinebanking").css("top", $(".headernav").outerHeight() + "px");
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Alert.init();
});